const _ = require('lodash')
const moment = require('moment')
const { generateBPStoreFolder } = require('../utils/bPStoreExportXlsx')
const {generateEmpiricFolder} = require("../utils/empiricExportXlsx");

export const entity = {
    name: 'BPStoreFolderExport',
    facets: [{ name: 'files', linkType: 'OTO' }],
    fields: [
        {
            type: 'ProjectConfiguration',
            link: { oppositeField: { link: { deleteType: 'cascade' } } }
        },
        { path: 'user', type: 'User', nullable: true },
        { path: 'date', dateFormat: 'YYYY-MM-DD HH:mm', type: 'date', nullable: true }
    ],
    beforeSave: function(object, oldObject, context, callback) {
        object.user = _.pick(context.user, ['id'])
        object.date = new Date()

        callback(null, object, oldObject)
    },
    afterSave: function(object, oldObject, context, callback) {
        generateBPStoreFolder(object, context)
            .then(result => {
                global.ioSocket.emit(
                    `fetchEditObject-success-${context.user.id}${context.clientContext.accessId}`,
                    result
                )
            })
            .catch(err => {
                console.error(err.message)
                global.ioSocket.emit(
                    `fetchEditObject-failure-${context.user.id}${context.clientContext.accessId}`,
                    {error: err.message}
                )
            })
        callback()
    },
    filters: [{
        name: 'onlyOwner',
        isDefault: true,
        query: function(context) {
            const userId = _.get(context, 'user.id')
            return userId
                ? { user: new global.ObjectID(userId) }
                : {_id: false}
        }
    }]
}
export const module_ = {
    object: 'BPStoreFolderExport',
    tKey: 'mTitle_bPStoreFolderExport',
    defaultSortBy: 'date',
    defaultSortDirection: 'DESC',
    useSocketsOnSave: true,
    updatable: false,
    editable: false,
    category: {
        path: 'bpStore',
        icon: 'briefcase'
    },
    viewMap: {
        dt: [
            {
                path: 'projectConfiguration',
                tKey: 'folder',
                display: 'projectId',
                width: 250
            },
            {path: 'date', width: 50},
            {path: 'file', width: 50}
        ],
        form: [
            {
                path: 'projectConfiguration',
                tKey: 'folder',
                display: 'projectId',
                filters: ['onlyAffectedSubsidiary']
            }
        ]
    }
}
